/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may ist use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { FC } from 'react';
import { WbCard } from '@agilelab/plugin-wb-platform';
import {
  PermissionContextProvider,
  PermissionsTable,
  RoleContextProvider,
  RolesTable,
} from '@agilelab/plugin-wb-rbac';
import { Grid } from '@material-ui/core';
import { UserSettingsIdentityCard } from './UserSettingsIdentityCard';
import { UserSettingsProfileCard } from './UserSettingsProfileCard';

interface UserSettingsGeneralProps {
  isGuestUser: boolean;
}

/** @public */
export const UserSettingsGeneral: FC<UserSettingsGeneralProps> = ({
  isGuestUser,
}) => {
  return (
    <Grid container direction="row" spacing={3}>
      <Grid item xs={12} md={6}>
        <UserSettingsProfileCard />
      </Grid>
      <Grid item xs={12} md={6}>
        <UserSettingsIdentityCard />
      </Grid>
      {!isGuestUser && (
        <Grid item xs={12} md={12}>
          <WbCard title="Roles">
            <RoleContextProvider>
              <RolesTable />
            </RoleContextProvider>
          </WbCard>
        </Grid>
      )}
      {!isGuestUser && (
        <Grid item xs={12} md={12}>
          <WbCard title="Permissions">
            <PermissionContextProvider>
              <PermissionsTable />
            </PermissionContextProvider>
          </WbCard>
        </Grid>
      )}
    </Grid>
  );
};
